import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/alexaI18n/importer/alexaI18nImporterActions';

export default importerReducers(actions);
